import React, { useState, useEffect } from 'react'
import moment from 'moment-timezone'
import { useGetAvailabilityMutation } from '../../Redux/LeaveManager/LeaveMangerSlice'
import { formatDate } from '../../Utils'

interface ShiftSectionProps {
    formType: string
    requesterId: number | undefined
    startDateTime: Date
    endDateTime: Date
}
interface Shift {
    shiftname: string
    DutyStartDateTime: string | Date
    DutyEndDateTime: string | Date
    hrs: number
    recommendation: number
}
interface Recommendation {
    shiftDate: string
    availableSlots: number
    slotName: string
}

const ShiftSection: React.FC<ShiftSectionProps> = React.memo(
    ({ formType, requesterId, startDateTime, endDateTime }) => {
        const [lmsShifts, setLmsShifts] = useState<Shift[]>([])
        const [renderRecommendations, setRenderRecommendations] = useState<boolean>(false)
        const [recommendationsData, setRecommendationsData] = useState<Recommendation[]>([])
        const [recommendationColumns, setRecommendationColumns] = useState<any[]>([]);

        const [
            GetShiftsAndRecommendations,
            { data: Shifts, error: ShiftError, isLoading: ShiftLoading },
        ] = useGetAvailabilityMutation()

        useEffect(() => {
            const fetchData = async () => {
                try {
                    function formatShiftsInput() {
                        // Wrap the keys inside "shiftsInput[]"
                        return {
                          'shiftsInput[requesterId]': requesterId,
                          'shiftsInput[startDateTime]': startDateTime,
                          'shiftsInput[endDateTime]': endDateTime,
                        };
                      }
                    const requestersResult = await GetShiftsAndRecommendations(formatShiftsInput()).unwrap()
                    const shifts = requestersResult.shiftDetails?.Value?.Data ?? []
                    const recommendations = requestersResult.recommendations.Value?.Data ?? []
                    let columnNames =
                        recommendations && recommendations[0] ? Object.keys(recommendations[0]) : []
                    setRecommendationColumns(columnNames)
                    setRecommendationsData(recommendations)
                    setLmsShifts(shifts)
                } catch (err) {
                    console.error('Error fetching data:', err)
                }
                if (formType === 'approver') {
                    setRenderRecommendations(true)
                }
            }

            fetchData()
        }, [startDateTime, endDateTime])

        const formatDateForBackend = (date: Date): string => {
            return date.toISOString()
        }

        // const setStartTime = (startingDate) => {
        //   const time = moment.utc(startingDate);
        //   const date = time.clone().tz('America/Los_Angeles');
        //   lmsShifts.setStartDateTime(date.format("YYYY-MM-DDTHH:mm:ss"));
        // };

        // const setEndTime = (endingDate) => {
        //   const time = moment.utc(endingDate);
        //   const date = time.clone().tz('America/Los_Angeles');
        //   lmsShifts.setEndDateTime(date.format("YYYY-MM-DDTHH:mm:ss"));
        // };

        // const setUser = (requesterId) => {
        //   lmsShifts.setRequesterId(requesterId);
        // };

        // const serializeData = () => {
        //   const shiftsData = lmsShifts.toJSON()?.shiftDetails?.Value?.Data ?? [];
        //   return {
        //     shiftDetails: shiftsData.map((x) => ({
        //       shiftname: x.shiftname,
        //       DutyStartDateTime: x.DutyStartDateTime,
        //       DutyEndDateTime: x.DutyEndDateTime,
        //       hrs: x.hrs,
        //       recommendation: x.recommendation,
        //     })),
        //   };
        // };

        // const toUTC = (dateTime) => {
        //   const time = moment.tz(dateTime, 'America/Los_Angeles');
        //   const date = time.utc();
        //   return date.format("YYYY-MM-DDTHH:mm:ss");
        // };

        return (
            <div>
                <div>
                    {/* Display the section only if shiftDetails is not empty */}
                    {lmsShifts && lmsShifts.length > 0 ? (
                        <>
                            <div className="row border">
                                <span
                                    className="col-3 p-1 border border-top-1 border-bottom-0 justify-content-center"
                                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                                >
                                    Shift Name
                                </span>
                                <span
                                    className="col-3 p-1 border border-top-1 border-bottom-0 border-left-0 justify-content-center"
                                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                                >
                                    Start
                                </span>
                                <span
                                    className="col-3 p-1 border border-top-1 border-bottom-0 border-left-0 justify-content-center"
                                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                                >
                                    End
                                </span>
                                <span
                                    className="col-3 p-1 border border-top-1 border-bottom-0 border-left-0 justify-content-center"
                                    style={{ fontWeight: 'bold', textAlign: 'center' }}
                                >
                                    Hrs
                                </span>
                            </div>

                            {lmsShifts.map((shift: Shift, index) => (
                                <div
                                    className={`row border LMS-row-${shift.recommendation}`}
                                    key={index}
                                >
                                    <div className="col-3 p-1 border border-top-1 border-bottom-0">
                                        {shift?.shiftname === 'total' ? (
                                            <span className="font-weight-bold">
                                                {shift.shiftname}
                                            </span>
                                        ) : (
                                            shift.shiftname
                                        )}
                                    </div>
                                    <div className="col-3 p-1 border border-top-1 border-bottom-0 border-left-0 font-weight-bold">
                                        {formatDate(shift.DutyStartDateTime)}
                                    </div>
                                    <div className="col-3 p-1 border border-top-1 border-bottom-0 border-left-0 font-weight-bold">
                                        {formatDate(shift.DutyEndDateTime)}
                                    </div>
                                    <div
                                        className="col-3 p-1 border border-top-1 border-bottom-0 border-left-0 font-weight-bold"
                                        style={{ textAlign: 'center' }}
                                    >
                                        {shift.hrs === null ? 0 : shift.hrs}
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : (
                        <div>No shifts found in the given date range</div>
                    )}

                    {renderRecommendations && (
                        <div id="recommendations_table">
                            <div className="row p-2 ">
                                {' '}
                                <b> Available Slots: </b>{' '}
                            </div>
                            <table>
                                {recommendationColumns && recommendationColumns.length > 0 && (
                                    <thead>
                                        <tr>
                                            {recommendationColumns.map((column: any, index: number) => (
                                                <th key={index} className="p-1 border" style={{ textAlign: 'center' }}>
                                                    {column}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                )}

                                <tbody>
                                    {recommendationsData && recommendationsData.length > 0 ? (
                                        recommendationsData.map((row: any, rowIndex: number) => (
                                            <tr key={rowIndex}>
                                                {recommendationColumns.map(
                                                    (col: any, colIndex: number) => (
                                                        <td key={colIndex}>{row[col]}</td> // Access each row by the column name
                                                    )
                                                )}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={recommendationColumns.length}
                                                className="p-1 border"
                                            >
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        )
    }
)

export default ShiftSection
